import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import pdfMake from 'pdfmake/build/pdfmake';
import domtoimage from 'dom-to-image';
import { MeasureService } from 'src/app/modules/measure/measure.service';
import { Logo } from 'src/app/shared/logo-encode';
import { DateTimePipe } from '../../pipe/date.pipe';
import { map } from 'rxjs/operators';

@Component({
  selector: 'lifedi-report-profile',
  templateUrl: './report-profile.component.html',
  styleUrls: ['./report-profile.component.scss'],
})
export class ReportProfileComponent implements OnInit {
  @Input() measureid: string;
  @Input() type: string;
  @Input() view_status: number;
  @Input() access_id: string;
  @Input() informant_type: string;
  isLoading: boolean;

  data_report;
  // data_report = [
  //   {
  //     reportname: 'รายงานแบบทดสอบ',
  //     measure_name: 'แบบทดสอบพัฒนา',
  //     report_description: 'คำอธิบายรายงานแบบทดสอบ',
  //     data: [
  //       {
  //         id: '0',
  //         psy_name: 'Fairness111',
  //         psy_description: 'คำอธิบายลักษณะทางจิตวิทยา',
  //         min: 0,
  //         max: 10,
  //         slider_value: 5,
  //         range: '3-5',
  //         range_description:
  //           'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //         color: '#40559F',
  //       },
  //       {
  //         id: '1',
  //         psy_name: 'Fairness2',
  //         psy_description: 'คำอธิบายลักษณะทางจิตวิทยา',
  //         min: 0,
  //         max: 10,
  //         slider_value: 8,
  //         range: '4-6',
  //         range_description: 'คำอธิบายxxxxxxx yyyyyyyyyyyyyyyyyyy',
  //         color: '#fd3d7e',
  //       },
  //       {
  //         id: '2',
  //         psy_name: 'Fairness3',
  //         psy_description: 'คำอธิบายลักษณะทางจิตวิทยา',
  //         min: 0,
  //         max: 10,
  //         slider_value: 4,
  //         range: '7-8',
  //         range_description: 'คำอธิบายxxxxxxx kkkkkkkkkkkkkkkkkkkkkkkkkkkkkk',
  //         color: '#40559F',
  //       },
  //     ],
  //   },
  // ];
  constructor(private measureService: MeasureService) { }

  ngOnInit(): void {
    this.isLoading = true;
    // setTimeout(() => {
    //   this.isLoading = false;
    // }, 1000);
    let body;

    if (this.access_id) {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        ACCESS_ID: this.access_id,
        INFORMANT_TYPE: this.informant_type,
      };
    } else {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        INFORMANT_TYPE: this.informant_type,
      };
    }

    this.measureService
      .getReportByMeasureId(body)
      .pipe(
        map((res) => {
          this.data_report = [res.result];
          console.log(this.data_report);
          setTimeout(() => {
            this.filepdf();
          }, 1000);
          this.isLoading = false;
        })
      )
      .subscribe();

  }

  downloadpdf() {
    let formattedDate = new DateTimePipe().transform(
      this.data_report[0].done_measure_date.toString(),
      'FullNoTime'
    );
    let userid = this.data_report[0].user_id;
    let username = this.data_report[0].username;
    this.isLoading = true;
    let alldata = this.data_report;
    let NewArray = [];
    for (let i = 0; i < alldata[0].data.length; i++) {
      let a = document.getElementById('sliderpdf' + i);
      NewArray.push(a);
      // NewArray.push("document.getElementById('sliderpdf" + i + "')");
    }
    // console.log(NewArray);

    Promise.all(NewArray.map((node) => domtoimage.toPng(node))).then(
      (dataArray) => {
        dataArray[0];
        let img1 = new Image();
        img1.src = dataArray[0];

        pdfMake.fonts = {
          THsarabunNew: {
            normal: 'THSarabun.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf',
          },
        };
        const allPage = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          header: function (currentPage) {
            return [
              {
                text: username + ' ( userid : ' + userid + ' )' + '  | ' + formattedDate + ' หน้า ' + currentPage.toString(),
                width: '*',
                alignment: 'right',
                margin: [40, 20],
              },
            ];
          },
          content: [
            {
              text: this.data_report[0].reportname,
              alignment: 'center',
              fontSize: 20,
              color: '#060e9f',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].measure_name,
              alignment: 'left',
              fontSize: 18,
              decoration: 'underline',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].report_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 15],
            },
            {
              text: this.data_report[0].data[0].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: this.data_report[0].data[0].COLOR_CODE,
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 16,
              bold: true,
              pageBreak: '',
              id: 'psyname',
            },
            {
              text: this.data_report[0].data[0].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              columns: [
                {
                  image: dataArray[0],
                  width: 180,
                  height: 100,
                  alignment: 'center',
                  margin: [0, -10, 10, 0],
                },
                [
                  {
                    text:
                      'คะแนนต่ำสุด : ' +
                      this.data_report[0].data[0].min +
                      '    คะแนนสูงสุด : ' +
                      this.data_report[0].data[0].max,
                    width: '*',
                    color: '#000000',
                    fontSize: 16,
                    bold: true,
                  },
                  {
                    text:
                      'ท่านได้ ' +
                      parseFloat(this.data_report[0].data[0].slider_value).toFixed(2) +
                      ' คะแนน',
                    // ' อยู่ในช่วงคะแนน ' +
                    // this.data_report[0].data[0].range +
                    // ' คะแนน',
                    width: '*',
                    color: this.data_report[0].data[0].COLOR_CODE,
                    margin: [0, 0, 0, 0],
                    fontSize: 16,
                    bold: true,
                  },
                ],
              ],
              // columnGap: 5,
            },
            {
              text: this.data_report[0].data[0].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, -50, 0, 30],
            },
          ],
          pageBreakBefore: function (currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {

            //check if last paragraph is entirely on a single page, add pagebreak if not
            if (currentNode && currentNode.id && currentNode.id.startsWith('psyname') && currentNode.pageNumbers.length != 1) {
              return true;
            }
            return false;
          },
          defaultStyle: {
            font: 'THsarabunNew',
          },
        };
        for (let i = 1; i < this.data_report[0].data.length; i++) {
          // dataArray[i];
          // let img1 = new Image();
          // img1.src = dataArray[i];
          dataArray[i];
          let img2 = new Image();
          img2.src = dataArray[i];
          let after = '';
          // if (i % 2 == 0) {
          //   after = 'before';
          // }

          allPage.content.push(
            {
              text: this.data_report[0].data[i].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: this.data_report[0].data[i].COLOR_CODE,
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 16,
              bold: true,
              pageBreak: after,
              id: 'psyname' + i,
            },
            {
              text: this.data_report[0].data[i].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 5],
            },
            {
              columns: [
                {
                  image: dataArray[i],
                  width: 180,
                  height: 100,
                  alignment: 'center',
                  margin: [0, -10, 10, 0],
                },
                [
                  {
                    text:
                      'คะแนนต่ำสุด : ' +
                      this.data_report[0].data[i].min +
                      '    คะแนนสูงสุด : ' +
                      this.data_report[0].data[i].max,
                    width: '*',
                    color: '#000000',
                    fontSize: 16,
                    bold: true,
                  },
                  {
                    text:
                      'ท่านได้ ' +
                      parseFloat(this.data_report[0].data[i].slider_value).toFixed(2) +
                      ' คะแนน',
                    // ' อยู่ในช่วงคะแนน ' +
                    // this.data_report[0].data[i].range +
                    // ' คะแนน',
                    width: '*',
                    color: this.data_report[0].data[i].COLOR_CODE,
                    margin: [0, 0, 0, 0],
                    fontSize: 16,
                    bold: true,
                  },
                ],
              ],
              // columnGap: 5,
            },
            {
              text: this.data_report[0].data[i].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, -50, 0, 30],
            },
          );
        }
        pdfMake.createPdf(allPage).open();
        this.isLoading = false;
      }
    );
  }
  filepdf() {
    let formattedDate = new DateTimePipe().transform(
      this.data_report[0].done_measure_date.toString(),
      'FullNoTime'
    );
    let userid = this.data_report[0].user_id;
    let alldata = this.data_report;
    let NewArray = [];
    for (let i = 0; i < alldata[0].data.length; i++) {
      let a = document.getElementById('sliderpdf' + i);
      NewArray.push(a);
      // NewArray.push("document.getElementById('sliderpdf" + i + "')");
    }
    // console.log(NewArray);

    Promise.all(NewArray.map((node) => domtoimage.toPng(node))).then(
      (dataArray) => {
        dataArray[0];
        let img1 = new Image();
        img1.src = dataArray[0];

        pdfMake.fonts = {
          THsarabunNew: {
            normal: 'THSarabun.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf',
          },
        };
        const allPage = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          header: function (currentPage) {
            return [
              {
                text:
                  userid +
                  ' | ' +
                  formattedDate +
                  ' หน้า ' +
                  currentPage.toString(),
                width: '*',
                alignment: 'right',
                margin: [40, 20],
              },
            ];
          },
          content: [
            {
              text: this.data_report[0].reportname,
              alignment: 'center',
              fontSize: 20,
              color: '#060e9f',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].measure_name,
              alignment: 'left',
              fontSize: 18,
              decoration: 'underline',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].report_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 15],
            },
            {
              text: this.data_report[0].data[0].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: this.data_report[0].data[0].COLOR_CODE,
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 16,
              bold: true,
              pageBreak: '',
              id: 'psyname',
            },
            {
              text: this.data_report[0].data[0].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              columns: [
                {
                  image: dataArray[0],
                  width: 180,
                  height: 100,
                  alignment: 'center',
                  margin: [0, -10, 10, 0],
                },
                [
                  {
                    text:
                      'คะแนนต่ำสุด : ' +
                      this.data_report[0].data[0].min +
                      '    คะแนนสูงสุด : ' +
                      this.data_report[0].data[0].max,
                    width: '*',
                    color: '#000000',
                    fontSize: 16,
                    bold: true,
                  },
                  {
                    text:
                      'ท่านได้ ' +
                      parseFloat(this.data_report[0].data[0].slider_value).toFixed(2) +
                      ' คะแนน',
                    // ' อยู่ในช่วงคะแนน ' +
                    // this.data_report[0].data[0].range +
                    // ' คะแนน',
                    width: '*',
                    color: this.data_report[0].data[0].COLOR_CODE,
                    margin: [0, 0, 0, 0],
                    fontSize: 16,
                    bold: true,
                  },
                ],
              ],
            },
            {
              text: this.data_report[0].data[0].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, -50, 0, 30],
            },
          ],
          pageBreakBefore: function (currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {

            //check if last paragraph is entirely on a single page, add pagebreak if not
            if (currentNode && currentNode.id && currentNode.id.startsWith('psyname') && currentNode.pageNumbers.length != 1) {
              return true;
            }
            return false;
          },
          defaultStyle: {
            font: 'THsarabunNew',
          },
        };
        for (let i = 1; i < this.data_report[0].data.length; i++) {
          dataArray[i];
          let img2 = new Image();
          img2.src = dataArray[i];
          let after = '';
          // if (i % 3 == 0) {
          //   after = 'before';
          // }

          allPage.content.push(
            {
              text: this.data_report[0].data[i].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: this.data_report[0].data[i].COLOR_CODE,
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 16,
              bold: true,
              pageBreak: after,
              id: 'psyname' + i,
            },
            {
              text: this.data_report[0].data[i].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 5],
            },
            {
              columns: [
                {
                  image: dataArray[i],
                  width: 180,
                  height: 100,
                  alignment: 'center',
                  margin: [0, -10, 10, 0],
                },
                [
                  {
                    text:
                      'คะแนนต่ำสุด : ' +
                      this.data_report[0].data[i].min +
                      '    คะแนนสูงสุด : ' +
                      this.data_report[0].data[i].max,
                    width: '*',
                    color: '#000000',
                    fontSize: 16,
                    bold: true,
                  },
                  {
                    text:
                      'ท่านได้ ' +
                      parseFloat(this.data_report[0].data[i].slider_value).toFixed(2) +
                      ' คะแนน',
                    // ' อยู่ในช่วงคะแนน ' +
                    // this.data_report[0].data[i].range +
                    // ' คะแนน',
                    width: '*',
                    color: this.data_report[0].data[i].COLOR_CODE,
                    margin: [0, 0, 0, 0],
                    fontSize: 16,
                    bold: true,
                  },
                ],
              ],
            },
            {
              text: this.data_report[0].data[i].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, -50, 0, 30],
            },
          );
        }
        var pdfDocGenerator = pdfMake.createPdf(allPage);
        pdfDocGenerator.getBase64((base64str) => {
          // console.log(base64str);
          let data = {
            MEASURE_ID: this.measureid,
            TYPE: this.type,
            base64str: base64str,
            view: this.view_status,
          };
          this.measureService.SaveReportMeasureId(data).subscribe((res) => {
            // // console.log(res);
          });
        });
      }
    );
  }
}
